/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'react-redux';
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import Adstxt from 'pages/dashboard/account/adstxt/adstxt';
import { getAdsTxt, verifyAdsTxt }  from 'state/actions/accountState/account_data';

// const testData = {
//     adsTxt: "Insticator.com,9f96ea51-07f4-4fa5-94d0-4532a807c19d,DIRECT\n" +
//         "google.com,pub-7630961163643137,RESELLER,f08c47fec0942fa0\n" +
//         "districtm.io,100683,RESELLER\n" +
//         "openx.com,537117488,RESELLER,6a698e2ec38604c6\n" +
//         "pubmatic.com,95054,RESELLER,5d62403b186f2ace\n" +
//         "appnexus.com,1908,RESELLER\n" +
//         "appnexus.com,3695,RESELLER\n" +
//         "appnexus.com,4052,RESELLER\n" +
//         "appnexus.com,1356,RESELLER,f5ab79cb980f11d1\n" +
//         "sonobi.com,e315a43aa9,RESELLER\n" +
//         "rhythmone.com,136898039,RESELLER,a670c89d4a324e47\n" +
//         "EMXDGT.com,22,RESELLER,1e1d41537f7cad7f\n" +
//         "rubiconproject.com,17062,DIRECT,0bfd66d529a55807\n" +
//         "contextweb.com,561664,RESELLER,89ff185a4c4e857c\n" +
//         "openx.com,537120960,RESELLER\n" +
//         "openx.com,83499,RESELLER\n" +
//         "openx.com,538959099,RESELLER\n" +
//         "pubmatic.com,137711,RESELLER\n" +
//         "pubmatic.com,156212,RESELLER\n" +
//         "pubmatic.com,62483,RESELLER\n" +
//         "contextweb.com,558511,RESELLER\n" +
//         "sovrn.com,257618,RESELLER,fafdf38b16bf6b2b\n" +
//         "lijit.com,257618,RESELLER,fafdf38b16bf6b2b\n" +
//         "openx.com,537102524,RESELLER,6a698e2ec38604c6\n" +
//         "brightcom.com,20796,DIRECT\n" +
//         "google.com,pub-5231479214411897,RESELLER,f08c47fec0942fa0\n" +
//         "openx.com,537153208,RESELLER\n" +
//         "smartadserver.com,2586,RESELLER\n" +
//         "contextweb.com,561437,RESELLER\n" +
//         "advertising.com,23302,RESELLER\n" +
//         "google.com,pub-4207323757133151,RESELLER\n" +
//         "33across.com,33,RESELLER\n" +
//         "appnexus.com,1001,RESELLER\n" +
//         "appnexus.com,3135,RESELLER\n" +
//         "districtm.io,101080,RESELLER\n" +
//         "appnexus.com,7944,RESELLER\n" +
//         "tremorhub.com,ntdd5,RESELLER,1a4e959a1b50034a\n" +
//         "freewheel.tv,118529,RESELLER\n" +
//         "lkqd.net,49,RESELLER,59c49fa9598a0117\n" +
//         "lkqd.com,49,RESELLER,59c49fa9598a0117\n" +
//         "taboola.com,1129575,RESELLER,c228e6794e811952\n" +
//         "spotx.tv,71451,RESELLER\n" +
//         "spotxchange.com,71451,RESELLER\n" +
//         "advertising.com,8603,RESELLER\n" +
//         "advertising.com,3531,RESELLER\n" +
//         "pubmatic.com,156307,RESELLER,5d62403b186f2ace\n" +
//         "appnexus.com,3364,RESELLER\n" +
//         "Indexexchange.com,183756,RESELLER\n" +
//         "contextweb.com,560382,RESELLER\n" +
//         "openx.com,539154393,RESELLER\n" +
//         "tremorhub.com,z87wm,RESELLER,1a4e959a1b50034a\n" +
//         "rubiconproject.com,16698,RESELLER,0bfd66d529a55807\n" +
//         "fyber.com,ad9de41d28d494354b23133f26f83122,RESELLER\n" +
//         "fyber.com,1a12a7e3f84fe560ccf95a3a73043abb,RESELLER\n" +
//         "rhythmone.com,1059622079,RESELLER\n" +
//         "contextweb.com,560606,RESELLER\n" +
//         "rubiconproject.com,17980,RESELLER,0bfd66d529a55807\n" +
//         "Rhythmone.com,527383184,RESELLER,a670c89d4a324e47\n" +
//         "indexexchange.com,187071,DIRECT\n" +
//         "indexexchange.com,187482,DIRECT\n" +
//         "openx.com,540105394,RESELLER,6a698e2ec38604c6\n" +
//         "pubmatic.com,157119,RESELLER,5d62403b186f2ace\n" +
//         "adtech.com,10064,RESELLER\n" +
//         "coxmt.com,2000067907202,RESELLER\n" +
//         "Openx.com,537143344,RESELLER\n" +
//         "indexexchange.com,175407,RESELLER\n" +
//         "pubmatic.com,156078,RESELLER,5d62403b186f2ace\n" +
//         "33across.com,0010b00001rrPUnAAM,DIRECT,bbea06d9c4d2853c#display\n" +
//         "gumgum.com,13344,DIRECT,ffdef49475d318a9\n" +
//         "somoaudience.com,a4ff0c581c4aa069dd953d98b42ae058,DIRECT\n" +
//         "mobileadtrading.com,a4ff0c581c4aa069dd953d98b42ae058,DIRECT\n" +
//         "openx.com,537120563,RESELLER,6a698e2ec38604c6#display\n" +
//         "openx.com,539392223,RESELLER,6a698e2ec38604c6#display\n" +
//         "conversantmedia.com,40291,DIRECT,03113cd04947736d\n" +
//         "openx.com,540031703,RESELLER,6a698e2ec38604c6\n" +
//         "appnexus.com,9393,DIRECT\n" +
//         "ssp.ynxs.io,185,RESELLER\n" +
//         "Smartadserver.com,3262,RESELLER\n" +
//         "rubiconproject.com,16414,RESELLER,0bfd66d529a55807#display\n" +
//         "gumgum.com,13318,DIRECT,ffdef49475d318a9\n" +
//         "Media.net,8CUNOIK86,DIRECT\n" +
//         "Media.net,8CUNOIK86,DIRECT\n" +
//         "gumgum.com,13318,DIRECT,ffdef49475d318a9\n" +
//         "ucfunnel.com,par-BE7E7ADB8D34EE2BF7BBD2899BB62A77,DIRECT\n" +
//         "aralego.com,par-BE7E7ADB8D34EE2BF7BBD2899BB62A77,DIRECT",
//     adsTxtComplete: false,
//     containsAdsTxt: true,
//     missingElements: ["pubmatic.com,95054,RESELLER,5d62403b186f2ace", "contextweb.com,561664,RESELLER,89ff185a4c4e857c", "openx.com,537102524,RESELLER,6a698e2ec38604c6",
//         "brightcom.com,20796,DIRECT", "google.com,pub-5231479214411897,RESELLER,f08c47fec0942fa0"
//     ]
// }



/* ========== ~~~~~~~~~~ BUTTON : PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({accountData, homeState, sessionStatus}) => ({
    adsTxtValues: accountData.adsTxt.adsTxtValues,
    missingElements: accountData.adsTxt.missingElements,
    adsTxtComplete: accountData.adsTxt.adsTxtComplete,
    containsAdsTxt: accountData.adsTxt.containsAdsTxt,
    adsTxtFetching: accountData.adsTxtFetching,
    selectedSite: accountData.adsTxt.selectedSite,
    sitesReceived: accountData.sitesReceived,
    sites: accountData.sites,
    fetchingSites: homeState.homeAnalyticsStatus.fetchingSites,
    accountUUID: sessionStatus.accountUUID
});

// map actions
const mapDispatchToProps = dispatch => ({
    getAdsTxt: (paramString, site) => dispatch(getAdsTxt(paramString, site)),
    verifyAdsTxt: (paramString) => dispatch(verifyAdsTxt(paramString))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Adstxt);